import { Edit, MoreVertical, Plus, Search, Trash, X } from "react-feather";
import styles from "./complaintnote.module.css";
import { Dropdown } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import { AddLogCallAPI } from "../../../../components/AddLogs";

const schemaNote = yup.object().shape({
    note: yup.string().required('This field is Required').max(200, 'Notes cannot be more than 200 characters'),
});

const ComplaintNote = ({ complaintData, setComplaintData, setLoading, setSnackbarMsg, setSnackbarOpen }) => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [searchKey, setSearchKey] = useState("");
    const [noteModalOpen, setNoteModalOpen] = useState(false);
    const [deleteNoteModalOpen, setDeleteNoteModalOpen] = useState(false);
    const [noteID, setNoteID] = useState(0);
    const [notes, setNotes] = useState([]);

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schemaNote)
    });

    useEffect(() => {
        if (complaintData) {
            let filteredData = complaintData?.notes;
            if (searchKey !== '') {
                filteredData = filteredData.filter((item) => item?.note.toLowerCase().includes(searchKey.toLowerCase()));
            }

            setNotes(filteredData);
        }
    }, [complaintData, searchKey]);

    const onSubmit = async (data) => {
        setLoading(true);
        setNoteModalOpen(false);
        const postData = data;
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        if (noteID) {
            axios.put(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/notes/' + noteID, postData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setLoading(false);
                setSnackbarMsg(response.data.message);
                setSnackbarOpen(true);
                let note = response.data.data;

                setComplaintData(prev => {
                    return {
                        ...prev, notes: prev.notes?.map(i => {
                            if (i?.id === noteID)
                                return { ...i, note: note?.note };
                            return i;
                        })
                    }
                });

                let logData = {
                    'title': 'Complaint new note is updated',
                    'description': [
                        'Name: ' + complaintData?.title,
                        'Complaint number: ' + complaintData?.complaint_no,
                        'Property: ' + complaintData?.property_name,
                        'Apartment: ' + complaintData?.apt_name,
                        'Tenant: ' + complaintData?.tenant_name,
                        'Comment: ' + note?.note,
                    ]
                }

                AddLogCallAPI(logData, this.token);
                setNoteID(0);
            }).catch(error => {
                setLoading(false);
                setNoteID(0);
                if (typeof error.response !== 'undefined')
                    toast.error(error.response.data.message);
            });
        } else {
            axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/notes', postData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setLoading(false);
                setSnackbarMsg(response.data.message);
                setSnackbarOpen(true);
                let note = response.data.data;

                setComplaintData(prev => {
                    return { ...prev, notes: [note]?.concat(prev.notes) }
                });

                let logData = {
                    'title': 'Complaint new note is created',
                    'description': [
                        'Name: ' + complaintData?.title,
                        'Complaint number: ' + complaintData?.complaint_no,
                        'Property: ' + complaintData?.property_name,
                        'Apartment: ' + complaintData?.apt_name,
                        'Tenant: ' + complaintData?.tenant_name,
                        'Comment: ' + note?.note,
                    ]
                }

                AddLogCallAPI(logData, this.token);
            }).catch(error => {
                setLoading(false);
                if (typeof error.response !== 'undefined')
                    toast.error(error.response.data.message);
            });
        }
    }

    const delConfirm = async () => {
        setLoading(true);
        setDeleteNoteModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/notes/' + noteID, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);
            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setNoteID(0);

            setComplaintData(prev => {
                return { ...prev, notes: prev.notes?.filter(ii => ii?.id !== noteID) }
            });
        }).catch(error => {
            setLoading(false);
            setNoteID(0);
        });
    }

    return (<div>
        <div className={`${styles.NotesSearchArea}`}>
            <div className={`${styles.NotesSearchMain}`}>
                <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => setSearchKey(e.target.value)} />
                <Search />
            </div>
            {(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint-note:create') > -1) && <button className={`${styles.AddNoteBu}`} onClick={(e) => { setNoteModalOpen(true); setNoteID(0); }}><Plus /></button>}
        </div>
        {noteModalOpen && !noteID && <div className={`${styles.AddCommDiv}`}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <textarea placeholder="Add text here..." type="text" className={`${styles.ReferCommentArea}`} name="note" ref={register}></textarea>
                    {errors.note && <p className={`${styles.ErrorM}`}>{errors.note.message}</p>}
                </div>
                <div className={`${styles.ButtonSec}`}>
                    <input type="button" value="Cancel" className={`${styles.CancelBU}`} onClick={(e) => { setNoteModalOpen(false); setNoteID(0); }} />
                    <input type="submit" value="Add" className={`${styles.AddBU}`} />
                </div>
            </form>
        </div>}

        {notes.map((itemNote, indexN) => {
            return <div className={`${styles.ReferBodySummCommNotes}`} key={indexN}>
                <img src={"/static/img/default_avataar.svg"} alt="" />
                <div className={`${styles.ReferBodySummCommBody}`}>
                    <div className={`${styles.NoteListTitle}`}>
                        <p className={`${styles.SummCommBodyName}`}>{itemNote.user_name} <span>{itemNote.role}</span></p>
                        <div className={`${styles.NoteListIcons}`}>
                            {(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint-note:update') > -1) && <Dropdown className={`${styles.DropDownMain}`}>
                                <Dropdown.Toggle id="dropdown-basic" className={`${styles.FilesUpCardDD}`}>
                                    <MoreVertical />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="DropDownMenuBoxCus">
                                    <Dropdown.Item className="DropDListWIcon" onClick={(e) => { setNoteModalOpen(true); setNoteID(itemNote?.id); }}><Edit /> Edit</Dropdown.Item>
                                    <Dropdown.Item className="DropDListWIcon" onClick={(e) => { setDeleteNoteModalOpen(true); setNoteID(itemNote?.id); }}><Trash /> Delete</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>}
                        </div>
                    </div>
                    <p className={`${styles.SummCommBodyDate}`}>{itemNote.time_str}</p>
                    <p className={`${styles.SummCommBodyText}`}>

                        {(noteModalOpen && noteID && (noteID === itemNote.id)) && <div className={`${styles.AddCommDiv}`}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div>
                                    <textarea placeholder="Add text here..." type="text" className={`${styles.ReferCommentArea}`} name="note" ref={register} defaultValue={itemNote?.note}></textarea>
                                    {errors.note && <p className={`${styles.ErrorM}`}>{errors.note.message}</p>}
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <input type="button" value="Cancel" className={`${styles.CancelBU}`} onClick={(e) => { setNoteModalOpen(false); setNoteID(0); }} />
                                    <input type="submit" value="Update" className={`${styles.AddBU}`} />
                                </div>
                            </form>
                        </div>}

                        {(!noteID) && itemNote?.note}


                    </p>
                </div>
            </div>
        })}

        {notes.length === 0 && <div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/nodata.svg" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>No Data Found</p>
        </div>}

        <Dialog
            open={deleteNoteModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => { setDeleteNoteModalOpen(false); setNoteID(0); }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">Delete Note<button onClick={(e) => { setDeleteNoteModalOpen(false); setNoteID(0); }}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">Are you sure you want to delete this item?</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="DeletePopupBU" onClick={(e) => delConfirm()}>Delete</Button>
                <Button onClick={(e) => { setDeleteNoteModalOpen(false); setNoteID(0); }} className="CancelPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

    </div>);
}

export default ComplaintNote;